import { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Spinner, Flex } from "@chakra-ui/react";
import { toaster } from "@/components/ui/toaster";
import { useTranslation } from "react-i18next";

export const ProtectedRoute = () => {
  const { fetchCurrentUser, isAuthenticated, isLoading } = useAuth();
  const [error, setError] = useState(false);
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
  const { t } = useTranslation(['auth']);
  const location = useLocation();

  useEffect(() => {
    const verifyUser = async () => {
      if (!isAuthenticated) {
        try {
          await fetchCurrentUser();
        } catch (err) {
          setError(true);
          toaster.create({
            description: t('errors.authFailed'),
            type: "warning",
            duration: 6000,
            closable: true,
          });
        } finally {
          setHasCheckedAuth(true);
        }
      } else {
        setHasCheckedAuth(true); // already logged in
      }
    };

    verifyUser();
  }, [fetchCurrentUser, t]);

  if (isLoading || !hasCheckedAuth) {
    return (
      <Flex height="100vh" alignItems="center" justifyContent="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (error || !isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return <Outlet />;
};
